const modalities = [
  {
    name: "Mix de Danças",
    isNew: false,
    icon: "ri-music-2-line",
    desc: "Uma aula dinâmica e animada com ritmos variados para movimentar o corpo e soltar a energia em grupo.",
    color: "from-[#F0CDCD]/50 to-[#fdf5f5]",
    iconBg: "bg-[#F0CDCD]/70",
    iconColor: "text-[#008C51]",
  },
  {
    name: "Funcional",
    isNew: false,
    icon: "ri-bar-chart-grouped-line",
    desc: "Treino dinâmico com exercícios que usam o peso do corpo para trabalhar força, resistência e coordenação, promovendo um condicionamento físico completo.",
    color: "from-[#CDE3BB] to-[#edf7e4]",
    iconBg: "bg-[#BCD033]/30",
    iconColor: "text-[#008C51]",
  },
  {
    name: "Beach Tennis",
    isNew: false,
    icon: "ri-trophy-line",
    desc: "Esporte praticado na areia que combina elementos do tênis e do vôlei, estimulando agilidade, movimento e interação entre os participantes.",
    color: "from-[#A4D8DE]/40 to-[#eaf6f8]",
    iconBg: "bg-[#A4D8DE]/60",
    iconColor: "text-[#008C51]",
  },
  {
    name: "Padel",
    isNew: true,
    icon: "ri-ping-pong-line",
    desc: "Modalidade de raquete jogada em quadra fechada, fácil de aprender e dinâmica, que combina estratégia, movimento e socialização.",
    color: "from-[#CDE3BB]/70 to-[#f3fbed]",
    iconBg: "bg-[#BCD033]/25",
    iconColor: "text-[#008C51]",
  },
];

export default function BodyModalities() {
  return (
    <section id="modalidades-corpo" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <div>
            <span className="text-[#A4D8DE] text-sm font-bold tracking-widest uppercase" style={{ filter: "brightness(0.75)" }}>Bloco 2 · 10h20–11h40</span>
            <h2 className="text-4xl font-extrabold text-[#008C51] mt-1">Modalidades Corpo</h2>
            <p className="text-gray-500 mt-2 text-sm max-w-md">
              Atividades mais dinâmicas que exploram o movimento, energia e interação. Hora de soltar o corpo!
            </p>
          </div>
          <div className="bg-[#A4D8DE]/40 text-[#008C51] text-sm font-bold px-5 py-2 rounded-full whitespace-nowrap">
            <i className="ri-check-line mr-1" />
            1 aula por pessoa
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {modalities.map((mod) => (
            <div
              key={mod.name}
              className={`relative bg-gradient-to-br ${mod.color} rounded-2xl p-6 transition-transform hover:-translate-y-1 duration-200 border border-transparent hover:border-[#A4D8DE]/40`}
            >
              {mod.isNew && (
                <span className="absolute top-4 right-4 bg-[#BCD033] text-white text-xs font-bold px-2.5 py-1 rounded-full">
                  NOVO
                </span>
              )}
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${mod.iconBg} mb-4`}>
                <i className={`${mod.icon} text-2xl ${mod.iconColor}`} />
              </div>
              <h3 className="text-xl font-extrabold text-[#008C51] mb-2">{mod.name}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{mod.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
